export default "__VITE_ASSET__HoCiLy_N__"